var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoachApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11,
    r: 11,
    fill: "#FF6633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1404 6.22304C16.5569 6.57071 16.621 7.20042 16.2835 7.62954L9.99269 15.6295C9.8186 15.8509 9.5611 15.9853 9.28486 15.9989C9.00862 16.0125 8.73987 15.904 8.54609 15.7007L5.77812 12.797C5.40252 12.403 5.40805 11.7699 5.79049 11.3829C6.17293 10.9959 6.78744 11.0016 7.16305 11.3956L9.169 13.4999L14.7752 6.37052C15.1127 5.9414 15.7239 5.87537 16.1404 6.22304Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachApproved);
export default __webpack_public_path__ + "static/media/CoachApproved.4efbcdbc5049965f46044d49365c4f00.svg";
export { ForwardRef as ReactComponent };